import React from 'react';
import Services from '../services/Services';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyFetching,
} from '../../../contextsProperty/ContextProperties';
import LoadingTab from '../LoadingTab';

const DescriptionServices = () => {
    const { services, toggleItemInCollection } = useProperty();
    const { serviceCategoriesList, serviceTypesList } =
        usePropertyComplementaryData();
    const { isFetching } = usePropertyFetching();

    if (isFetching) {
        return <LoadingTab />;
    }

    return (
        <Services
            titlePage='what_services_does_your_property_have'
            titleServices='your_hotel_services'
            selectedServices={services}
            optionsCategories={serviceCategoriesList}
            options={serviceTypesList}
            onClickService={toggleItemInCollection}
        />
    );
};

export default DescriptionServices;
